import ytPlayBtn from "../../../../../assets/images/YouTube_play_button.svg";
import { Tag } from 'antd';
export const PreviewTab = ({ responseData, PlayVimeoVideoHandler, convertToStandardURL, PlayVideoHandler, loading, CompLoader, color }) => {
  function replaceUnderscoreWithSpace(str) {
    return str?.replace(/_/g, ' ')?.toLowerCase();
  }
  return (

    <div className="rowBody preview-tab-container">
      {loading ? (
        <CompLoader />
      ) :
        responseData &&
          responseData.length > 0 ? (
          responseData.map((data, i) => {
            return (
              <div
                className="preview-item-container"
                style={{ borderLeft: `5px solid ${color[i % 7]}` }}
              >
                <div className="gutter-row tabContent" style={{width: '100%'}}>
                  <div className="tagTextRow">
                    <div className="tagTextCol">{data?.title || data?.assetTitle || data?.subTitle || data?.experienceOfWorkTitle}</div>
                    <div className="tagTextCol">
                      {data?.experienceOfWorkTitle && data?.experienceOfWorkOpportunityOutput?.opportunityType && (
                        <Tag color="blue" className="tagText" style={{ marginLeft: 4 }}>{replaceUnderscoreWithSpace(data.experienceOfWorkOpportunityOutput.opportunityType)}</Tag>
                      )}
                    </div>

                  </div>
                </div>
                <div className="gutter-row" span={9}>
                  {data.mediaLink?.mediaType == "SOCIAL_MEDIA" ? (
                    <div
                      className="sliderImg videoOverlay"
                      onClick={PlayVideoHandler.bind(
                        this,
                        data.mediaLink?.url,
                        data.mediaLink?.mediaType
                      )}
                    >
                      {(() => {
                        const standardURL = convertToStandardURL(
                          data.mediaLink?.url
                        );
                        const videoID = new URLSearchParams(
                          new URL(standardURL).search
                        ).get("v");
                        return (
                          <>
                            <img
                              src={`https://img.youtube.com/vi/${videoID}/hqdefault.jpg`}
                              style={{ objectFit: "cover" }}
                              alt=""
                              className="video-preview-image"
                            />
                            <img
                              className="ytBtnOverlay"
                              src={ytPlayBtn}
                              onClick={() =>
                                PlayVideoHandler(
                                  data.mediaLink?.url,
                                  data.mediaLink?.mediaType
                                )
                              }
                            />
                          </>
                        );
                      })()}
                    </div>
                  ) : data?.mediaLink?.mediaType ==
                    "VIMEO_MEDIA" ? (
                    <div
                      className="sliderImg videoOverlay"
                      onClick={PlayVimeoVideoHandler.bind(
                        this,
                        data.mediaLink?.url,
                        data.mediaLink?.mediaType
                      )}
                    >
                      <img
                        src={`https://vumbnail.com/${data.mediaLink.url.split("/")[4]
                          }.jpg`}
                        alt=""
                        className="video-preview-image"
                      />
                      <img
                        className="ytBtnOverlay"
                        src={ytPlayBtn}
                        onClick={PlayVideoHandler.bind(
                          this,
                          data.mediaLink?.url,
                          data.mediaLink?.mediaType
                        )}
                      />
                    </div>
                  ) : data?.mediaLink?.mediaType == "IMAGE" ? (
                    <div className="sliderImg-alt">
                      <img
                        src={data.mediaLink?.url}
                        className="preview-img"
                      />
                    </div>
                  ) : (
                    <div className="sliderImg-alt">
                      <div className="preview-img"></div>
                    </div>
                  )}
                </div>
              </div>
            );
          })
        ) : (
          <div className="background-container">
            <span>Nothing here at the moment</span>
          </div>
        )}
    </div>


  )


}
